import redThemeImg from './certificateDefault.png';

export const defaultTheme = { redThemeImg };
